import { Box, Text } from '@ksyos/design-system';

export function MfaAppsInfo() {
    return (
        <>
            <Text>
                Installeer een verificatieapp op je smartphone. Heb je al een verificatieapp? Dan kan je die ook voor
                Ksyos gebruiken.
                <br />
                <br />
                Wij raden deze apps aan. Je vindt ze in de App Store of op Google Play.
            </Text>
            <Box
                display="flex"
                justifyContent="space-around"
            >
                <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                >
                    <img
                        alt="Google Authenticator"
                        src="/assets/images/google-authenticator.svg"
                        style={{ height: '80px' }}
                    />
                    <Text
                        fontWeight="medium"
                        mt={4}
                        size="sm"
                        textAlign="center"
                    >
                        Google Authenticator
                    </Text>
                </Box>
                <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                >
                    <img
                        alt="Microsoft Authenticator"
                        src="/assets/images/microsoft-authenticator.svg"
                        style={{ height: '80px' }}
                    />
                    <Text
                        fontWeight="medium"
                        mt={4}
                        size="sm"
                        textAlign="center"
                    >
                        Microsoft Authenticator
                    </Text>
                </Box>
            </Box>

            <Text
                color="minimal"
                size="sm"
            >
                Heb je een verificatieapp op je smartphone geïnstalleerd?
                <br />
                Ga dan verder.
            </Text>
        </>
    );
}
